import { createRouter, createWebHashHistory } from "vue-router";


const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {path: "/",redirect: '/home'},
        {path: '/home', name: 'home',
            component: () => import('../views/home.vue'),
            meta: {title: '', layout: 'default', requireAuth: true,}
        },
        {path: '/jobList', name: 'jobList',
            component: () => import('../views/jobList.vue'),
            meta: {title: '职位列表', layout: 'default', requireAuth: true,}
        },
        {path: '/corporationList', name: 'corporationList',
            component: () => import('../views/corporationList.vue'),
            meta: {title: '企业列表', layout: 'default', requireAuth: true,}
        },
    ],
});

export default router

